export const signatureCases = [
  {
    id: "harborfront",
    slug: "harborfront-cultural-pavilion",
    label: "Signature Proje",
    title: "Harborfront Cultural Pavilion",
    intro:
      "Toronto liman hattında konumlanan Harborfront Cultural Pavilion, kamusal sanat ve kentsel yaşamı aynı çatı altında buluşturan hibrit bir deneyim alanı olarak kurgulandı. Tasarım sürecinde pavilyon kabuğundan suya inen promenada kadar tüm hacimler, günün farklı ışık koşullarında nefes alacak şekilde yeniden modellendi.",
    meta: [
      "Konum: Toronto Waterfront",
      "Ölçek: 32000 m2 masterplan",
      "Teslim: 12 haftalık sprint",
      "Araçlar: 3ds Max, Corona, RailClone, Unreal",
    ],
    body: [
      "Projenin omurgasını oluşturan sahil promenadı, gün boyunca etkinlik temposuna uyum sağlayacak şekilde ışık senaryolarıyla test edildi. Kabuğun geçirgen metal örgüsü, gün ışığında gölgeleme deseni oluştururken, gece modunda LED ağ ile aktif hale getirildi.",
      "Pavilyonun merkezindeki çok amaçlı amfi, kamusal sanat performansları için 240 derece izleme açısı sağlayan terraced seating ile modellendi. Suya değen kademelerde sis ve yansıma simülasyonları kullanılarak ziyaretçinin mekansal deneyimi güçlendirildi.",
    ],
    timeline: [
      {
        title: "Konsept & veri toplama",
        description:
          "Survey datası, lidar taraması ve mevcut masterplan girdileri tek BIM modelinde birleştirilerek hızlı iterasyon ortamı kuruldu.",
      },
      {
        title: "Işık & materyal senaryosu",
        description:
          "Gün doğumu, golden hour ve gece modları için üç ayrı ışık rig'i oluşturuldu; kabuk panelleri için parametrik metal shader üretildi.",
      },
      {
        title: "Sunum & interaktif",
        description:
          "XR showroom için Unreal sahnesi hazırlandı, yatırımcı sunumuna yönelik 8K still seti ve kamera rotalı kısa video teslim edildi.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?auto=format&fit=crop&w=1400&q=80",
        alt: "Harborfront Cultural Pavilion gün batımı render",
      },
      {
        src: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1400&q=80",
        alt: "Harborfront promenad gece sahnesi",
      },
      {
        src: "https://images.unsplash.com/photo-1559767943-9066eb0f05a4?auto=format&fit=crop&w=1400&q=80",
        alt: "Kültürel pavilyon iç avlu perspektifi",
      },
      {
        src: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
        alt: "Amfi basamaklarında ışık enstalasyonu",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Harborfront%20Cultural%20Pavilion%20Case",
  },
  {
    id: "lynx-sky-gardens",
    slug: "lynx-sky-gardens",
    label: "Signature Proje",
    title: "Lynx Sky Gardens",
    intro:
      "Marina Bay hattı üzerinde yükselen Lynx Sky Gardens, şehrin ısı adası etkisini azaltmak için üç katmanlı asma bahçe sistemiyle tasarlandı. Parametrik çelik kaburga, nem ve rüzgâr simülasyonlarından elde edilen verilerle optimize edilerek kent siluetine hafif bir yeşil bant ekliyor.",
    meta: [
      "Konum: Marina Bay, Singapur",
      "Ölçek: 14000 m2 asma bahçe",
      "Teslim: 8 haftalık sprint",
      "Araçlar: Rhino, 3ds Max, V-Ray, SpeedTree",
    ],
    body: [
      "Gölgelik modülleri, CFD analizleri ile belirlenen hava akışını yönlendirerek 4°C'lik konfor artışı sağladı. Bitkilendirme zonları, evapotranspirasyon verilerinden beslenen algoritma ile seçildi ve gün içinde ışık düzeyine göre otomatik sulama senaryoları üretildi.",
      "Ziyaretçi rotası boyunca her 40 metrede açılan ışık nişleri, biyofilik anlatıyı güçlendirirken LED tavan paneli dinamik olarak iklim verilerini yansıtıyor. Gece modunda holografik yönlendirmeler ve sis efektiyle yüzen bir orman hissi elde edildi.",
    ],
    timeline: [
      {
        title: "Şehir verisi ve konsept",
        description:
          "Mobilite datası, gölge analizleri ve rüzgâr şemalarını tek BIM dosyasında birleştirerek köprü akslarını belirledik.",
      },
      {
        title: "Microclimate simülasyonu",
        description:
          "CFD sonuçlarına göre gölgelik eğimleri revize edildi, bitki türleri evapotranspirasyon katsayıları ile eşleştirildi.",
      },
      {
        title: "Sunum ve lansman",
        description:
          "AR navigasyon, LED tavan mapping ve fotogerçekçi 8K still setiyle yatırımcı lansmanı desteklendi.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1400&q=80",
        alt: "Lynx Sky Gardens üst kot render",
      },
      {
        src: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1400&q=80",
        alt: "Asma promenadın gece ışıklandırması",
      },
      {
        src: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1400&q=80",
        alt: "Çift katlı serra köprüsü perspektifi",
      },
      {
        src: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1400&q=80",
        alt: "Yağmur ormanı bitki seçkisi detay render",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Lynx%20Sky%20Gardens%20Case",
  },
  {
    id: "solstice-desert-resort",
    slug: "solstice-desert-resort",
    label: "Signature Proje",
    title: "Solstice Desert Resort",
    intro:
      "Liwa Çölü kum tepeleri arasında yer alan Solstice Desert Resort, çöl mikroklimasını misafir lehine yöneten biomimetik gölgelik modülleriyle kurgulandı. Güneşi takip eden tensil membranlar, radyasyon piklerinde açılarak resort boyunca serin hava akışı oluşturuyor.",
    meta: [
      "Konum: Liwa Çölü, BAE",
      "Ölçek: 65000 m2 wellness resort",
      "Teslim: 10 haftalık sprint",
      "Araçlar: 3ds Max, Corona, Phoenix FD, Unreal",
    ],
    body: [
      "Kum tepelerinin doğal geometrisi, Phoenix FD ile simüle edilen rüzgâr verileri sayesinde stabil hale getirildi ve gölgeliklerin taşıyıcıları bu sonuçlara göre yeniden belirlendi. Gece konforu için zemindeki radyan soğutma kanalları, ısı haritaları üzerinden optimize edildi.",
      "Çöl spa deneyimi, tuz buharı odaları ve meditasyon lagünü gibi niş programları kapsayacak şekilde katmanlandı. İç mekanlarda kullanılan tadelek sıva ve ıslak hacim ışık setleri, sıcaklık kontrastını dramatize edecek biçimde tonemapped olarak sunuldu.",
    ],
    timeline: [
      {
        title: "Topo ve rüzgâr çözümlemesi",
        description:
          "LiDAR kum tepesi verilerini temizledik, rüzgâr yönleri için birleştirilmiş CFD senaryoları üzerinden taşıyıcı aksları tanımladık.",
      },
      {
        title: "Termal konfor prototipi",
        description:
          "Ladybug ve Radiance ile membran açıklıklarını test edip gündüz/gece sıcaklık eğrisini konuk konforu için dengeledik.",
      },
      {
        title: "Sunum koreografisi",
        description:
          "Interaktif VR rotası, 8K still seti ve 60 saniyelik teaser animasyonuyla lansman paketi teslim edildi.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1400&q=80",
        alt: "Solstice Desert Resort kum tepesi masterplan render",
      },
      {
        src: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=80",
        alt: "Resort ana avlusu akşam atmosferi",
      },
      {
        src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80",
        alt: "Gölgelik modüllerinin gün içinde dönüşü",
      },
      {
        src: "https://images.unsplash.com/photo-1534080564583-6be75777b70a?auto=format&fit=crop&w=1400&q=80",
        alt: "Spa pavilyonunun iç mekanda ışık oyunu",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Solstice%20Desert%20Resort%20Case",
  },
  {
    id: "neva-skyline-arts-center",
    slug: "neva-skyline-arts-center",
    label: "Signature Proje",
    title: "Neva Skyline Arts Center",
    intro:
      "Neva Skyline Arts Center, St. Petersburg kıyısında kültür ve performansı bir araya getiren iki katmanlı cam kabuğa sahip. Kış aylarında buz tutan nehirle ilişki kurmak için çift cephe sistemini dramatik bir ışık kutusuna dönüştürdük.",
    meta: [
      "Konum: St. Petersburg, Rusya",
      "Ölçek: 18000 m2 kültür kompleksi",
      "Teslim: 9 haftalık sprint",
      "Araçlar: Blender, Cycles, Houdini, Nuke",
    ],
    body: [
      "Çift kabuklu cephe, -18°C dış ortamda iç mekânda doğal ışığı tutmak için diferansiyel cam katmanlarıyla simüle edildi. Houdini ile kurgulanan buz parçacıkları, kıyıdaki sanat yürüyüşüne sinematik bir atmosfer kattı.",
  "Akustik kabuklar ve sahne rigging çözümleri, parametrik yüzeyler üzerine projeksiyon mapping ile harmanlandı. Performans aralarında ışık heykellerini destekleyen volumetrik sis, mekânsal deneyimi zenginleştirdi.",
    ],
    timeline: [
      {
        title: "Arşiv ve form araştırması",
        description:
          "Tarihi depo referanslarını tarayarak mimari formu oluşturduk, yerel yönetmeliklere uygun kitlesel oranlar ürettik.",
      },
      {
        title: "Işık dramaturjisi",
        description:
          "Gündüz, alacakaranlık ve gece için üç farklı volumetrik ışık seti oluşturarak atmosfer geçişlerini storyboard ile eşleştirdik.",
      },
      {
        title: "Sunum orkestrasyonu",
        description:
          "Kısa film, interaktif 360° tur ve LED duvar koreografisini tek sunum dosyasında bir araya getirdik.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1465805139202-a644e217f00e?auto=format&fit=crop&w=1400&q=80",
        alt: "Neva Skyline Arts Center dış cephe render",
      },
      {
        src: "https://images.unsplash.com/photo-1505842465776-3acb7eebc83c?auto=format&fit=crop&w=1400&q=80",
        alt: "Kültür merkezi foyesinin gece görünümü",
      },
      {
        src: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
        alt: "Çift cephe galerinin iç perspektifi",
      },
      {
        src: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=1400&q=80",
        alt: "Neva kıyısında açık hava performans sahnesi",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Neva%20Skyline%20Arts%20Center%20Case",
  },
  {
    id: "cascadia-forest-therme",
    slug: "cascadia-forest-therme",
    label: "Signature Proje",
    title: "Cascadia Forest Therme",
    intro:
      "Cascadia Forest Therme, yağmur ormanı vadisine yerleşen termal havuz kaskatlarıyla doğal hidro döngüyü yeniden koreograf ediyor. Kubbeler, orman örtüsünü bozmayacak şekilde yerel kayalıkların arasına gömülü olarak modellendi.",
    meta: [
      "Konum: Whistler, Kanada",
      "Ölçek: 22000 m2 spa kampüsü",
      "Teslim: 7 haftalık sprint",
      "Araçlar: Revit, 3ds Max, Corona, TyFlow",
    ],
    body: [
      "Havuz kademeleri, TyFlow parçacıklarıyla simüle edilen buhar hareketleri sayesinde birbirine bağlandı ve sahnenin genel atmosferi kontrollü sisle desteklendi. Ahşap kabuklar için taranan malzeme kaplamaları, gerçek dünya PBR datasıyla eşleştirildi.",
      "Ziyaretçilerin spa deneyimi boyunca karşılaştığı dijital dokunma noktaları, sauna ve meditasyon alanlarına entegre edilen interaktif medya yüzeyleriyle senkronize edildi. Bu sayede analog spa ritüeli ile dijital rehberlik arasında yumuşak bir geçiş sağlandı.",
    ],
    timeline: [
      {
        title: "Arazi ve su analizleri",
        description:
          "Jeolojik kesitleri ve kaynak su debisini modelleyerek havuz kotlarını belirledik, flora verileriyle çatışmayan patikalar kurguladık.",
      },
      {
        title: "Atmosfer tasarımı",
        description:
          "Buhar, sis ve ışık kombinasyonlarını TyFlow ve Corona Volume ile test ederek hedeflenen termal atmosferi yakaladık.",
      },
      {
        title: "Sunum entegrasyonu",
        description:
          "Interaktif dokunmatik masaya uygun 4K pano, 8K still seti ve kısa tanıtım filmiyle yatırımcı sunumu paketlendi.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1400&q=80",
        alt: "Cascadia Forest Therme ana havuz perspektifi",
      },
      {
        src: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
        alt: "Sis içinde orman yürüyüş yolu render",
      },
      {
        src: "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=80",
        alt: "Ahşap pavilyonun akşam atmosferi",
      },
      {
        src: "https://images.unsplash.com/photo-1431440869543-efaf3388c585?auto=format&fit=crop&w=1400&q=80",
        alt: "Orman gölgeliği ve sıcak su havuzu",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Cascadia%20Forest%20Therme%20Case",
  },
  {
    id: "isola-marina-observatory",
    slug: "isola-marina-observatory",
    label: "Signature Proje",
    title: "Isola Marina Observatory",
    intro:
      "Isola Marina Observatory, Amalfi kayalıkları boyunca deniz bilimi, gastronomi ve kamu deneyimini bir araya getiren panoramik bir pavilyon olarak tasarlandı. Kayaya gömülen kademeli teraslar, gelgit döngülerini canlı olarak izleyecek şekilde konumlandırıldı.",
    meta: [
      "Konum: Amalfi Kıyısı, İtalya",
      "Ölçek: 4800 m2 gözlem pavilyonu",
      "Teslim: 6 haftalık sprint",
      "Araçlar: Rhino, Enscape, Unreal, Houdini",
    ],
    body: [
  "Kıyı jeolojisi taranarak her teras için farklı dalga çarpma seviyeleri simüle edildi ve gelgit havuzlarında canlı veri projeksiyonu sağlandı. Houdini ile oluşturulan köpük ve su parçacıkları, render setine gerçekçi sprey etkisi kattı.",
  "Üst galeride yer alan gastronomi barı, gece modunda biyolüminesans efektleriyle hareketlenen aydınlatma senaryosuna sahip. Ziyaretçi rotası, suyun çekildiği anlarda ortaya çıkan mikro ekosistemleri vurgulayan ses peyzajıyla tamamlandı.",
    ],
    timeline: [
      {
  title: "Jeoloji ve dalga analizi",
        description:
          "Fotogrametri ile alınan kayalık yüzeylerini meshledik, dalga çarpma yüksekliklerini simüle ederek teras kodlarını belirledik.",
      },
      {
        title: "Malzeme prototipleme",
        description:
          "Deniz tuzuna dayanıklı beton karışımı için PBR kütüphanesi oluşturduk, gece modunda LED izleriyle vurguladık.",
      },
      {
        title: "Ziyaretçi deneyimi",
        description:
          "Ses, ışık ve koku senaryolarını tek storyboard üzerinde birleştirip Unreal sahnesinde interaktif tur haline getirdik.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1505731132164-cca90385e0ad?auto=format&fit=crop&w=1400&q=80",
        alt: "Isola Marina Observatory kıyı terası render",
      },
      {
        src: "https://images.unsplash.com/photo-1529429617124-aeea3b5f6d04?auto=format&fit=crop&w=1400&q=80",
        alt: "Gelgit havuzlarının üstten görünümü",
      },
      {
        src: "https://images.unsplash.com/photo-1503389152951-9f343605f61e?auto=format&fit=crop&w=1400&q=80",
        alt: "Kayalıkların içinden geçen yürüyüş tüneli",
      },
      {
        src: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1400&q=80",
        alt: "Deniz araştırma laboratuvarı gece perspektifi",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Isola%20Marina%20Observatory%20Case",
  },
  {
    id: "atlas-innovation-campus",
    slug: "atlas-innovation-campus",
    label: "Signature Proje",
    title: "Atlas Innovation Campus",
    intro:
      "Atlas Innovation Campus, Berlin Mediaspree kıyısında teknoloji şirketlerini, start-up stüdyolarını ve kamusal üretim alanlarını aynı çatıda toplayan bir inovasyon ekосistemi. Endüstriyel miras dokusu korunurken yeni hacimler çelik mesh kabuklarla vurgulandı.",
    meta: [
      "Konum: Mediaspree, Berlin",
      "Ölçek: 54000 m2 teknoloji kampüsü",
      "Teslim: 11 haftalık sprint",
      "Araçlar: Revit, 3ds Max, Corona, Unreal",
    ],
    body: [
      "Kampüs dolaşım halkası, esnek coworking modülleri ve dijital üretim atölyeleri arasında 24 saat yaşayan bir grid oluşturdu. Dijital twin modeli, gerçek zamanlı sıcaklık ve doluluk verilerini görselleştirerek tesis yönetimi kararlarını hızlandırdı.",
      "Showroom katında yer alan demo laboratuvarı, kullanıcıların prototip süreçlerini izleyebileceği şeffaf bir stüdyoya dönüştürüldü. İç mekân ışık senaryosu, dinamik gün ışığı takibiyle çalışan adaptif akıllı camlar üzerinden kurgulandı.",
    ],
    timeline: [
      {
        title: "Masterplan ve dolaşım",
        description:
          "Mevcut fabrika kabuklarını tarayarak yeni blokları yerleştirdik, yaya ve micromobility akışını tek plan üzerinde çözdük.",
      },
      {
        title: "Enerji ve materyal senaryosu",
        description:
          "Façade enerji performansını test edip fotovoltaik panelleri mesh kabuğa entegre ettik, malzeme paletini döngüsel ekonomi kriterleriyle seçtik.",
      },
      {
        title: "Sunum ve kiracı lansmanı",
        description:
          "Kiracı seçim süreci için 360° tur, leasing broşürü ve interaktif kat planı konfiguratorünü yayına aldık.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1400&q=80",
        alt: "Atlas Innovation Campus ana atriyum render",
      },
      {
        src: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1400&q=80",
        alt: "Kampüs coworking galerisi",
      },
      {
        src: "https://images.unsplash.com/photo-1505842465776-3acb7eebc83c?auto=format&fit=crop&w=1400&q=80",
        alt: "Atlas Innovation Campus gece silueti",
      },
      {
        src: "https://images.unsplash.com/photo-1491884662610-dfcd28f30cf5?auto=format&fit=crop&w=1400&q=80",
        alt: "Makerspace laboratuvarı üretim hattı",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Atlas%20Innovation%20Campus%20Case",
  },
  {
    id: "cerulean-harbor-residences",
    slug: "cerulean-harbor-residences",
    label: "Signature Proje",
    title: "Cerulean Harbor Residences",
    intro:
      "Cerulean Harbor Residences, Kopenhag Nordhavn limanında suyla temas eden yaşam deneyimini vurgulayan bir konut masterplanı. Kademeli teraslar, kanal boyunca kesintisiz yürüyüş rotası ve su sporları servislerini entegre ediyor.",
    meta: [
      "Konum: Nordhavn, Kopenhag",
      "Ölçek: 38000 m2 rezidans masterplanı",
      "Teslim: 9 haftalık sprint",
      "Araçlar: 3ds Max, Corona, RailClone, SpeedTree",
    ],
    body: [
      "Su seviyesi değişimlerini dikkate alan teras kesitleri, RailClone ile parametrik olarak üretildi ve günün farklı ışık saatlerinde gölge analizi yapıldı. Kıyı peyzajı, yerel flora referanslarıyla sahneye entegre edilerek dört mevsimlik bir senaryo oluşturdu.",
      "İç mekânlarda kullanılan pastel palet, İskandinav tasarım DNA'sını modernize eden lineer aydınlatmalar ve custom mobilya setleriyle tamamlandı. Satış galerisi için hazırlanan sanal tur, kullanıcıya üç farklı daire tipinde ışık modu seçme imkânı verdi.",
    ],
    timeline: [
      {
        title: "Waterfront analiz",
        description:
          "Deniz seviyesi projeksiyonları ve kanal rüzgâr verilerini modelleyerek iskele kotlarını ve kamusal bantları belirledik.",
      },
      {
        title: "İç mekân konsepti",
        description:
          "Show flat için üç renk paleti geliştirdik, fotogerçekçi renderlarla malzeme kombinasyonlarını test ettik.",
      },
      {
        title: "Satış sunumu",
        description:
          "Tablet uyumlu konfigüratör, 8K görsel arşivi ve basılı kitapçıkla satış takımlarını destekledik.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=1400&q=80",
        alt: "Cerulean Harbor waterfront cephe render",
      },
      {
        src: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1400&q=80",
        alt: "Liman promenadında akşam yürüyüşü",
      },
      {
        src: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
        alt: "Konsept daire terası",
      },
      {
        src: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=1400&q=80",
        alt: "Kanal üstü köprü ve peyzaj aksı",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Cerulean%20Harbor%20Residences%20Case",
  },
  {
    id: "aurelia-vertical-farm",
    slug: "aurelia-vertical-farm",
    label: "Signature Proje",
    title: "Aurelia Vertical Farm Tower",
    intro:
      "Aurelia Vertical Farm Tower, Seul skyline'ında gıda üretimini kamusal yaşamla buluşturan spiralli bir agro-teknoloji kulesi. Çift kabuklu cam cephe, güneş açısına göre açılıp kapanan akıllı panellerle kontrollü iklim yaratıyor.",
    meta: [
      "Konum: Yeongdeungpo, Seul",
      "Ölçek: 26000 m2 agro-teknoloji kulesi",
      "Teslim: 8 haftalık sprint",
      "Araçlar: Rhino, Grasshopper, Enscape, Unreal",
    ],
    body: [
      "Helisel katmanlar, bitki türlerinin ışık ve nem gereksinimlerine göre Grasshopper üzerinden parametrik olarak dağıtıldı. Hidroponik hatlar, gün içi enerji tüketimini düşürecek şekilde gri su geri dönüşüm sistemiyle entegre edildi.",
      "Topluluk mutfağı ve eğitim stüdyoları, üretim alanı ile şeffaf cam platform üzerinden bağlanarak şehirde gıda üretimi farkındalığını artırdı. AR destekli saha turu ile ziyaretçiler, ürün rotasını tohumdan masaya kadar izleyebildi.",
    ],
    timeline: [
      {
        title: "Parametrik ızgara",
        description:
          "İklim verilerini Grasshopper algo setine aktarıp bitki zonlarını optimize ettik, taşıyıcı spiral kurgusunu belirledik.",
      },
      {
        title: "Işık ve tarım senaryosu",
        description:
          "LED spektrumunu bitki ihtiyacına göre ayarladık, nem sensörlerini dijital twin ile entegre ettik.",
      },
      {
        title: "Sunum ve yatırımcı decki",
        description:
          "Modüler gelir modeli görselleri, 8K render seti ve yatırımcı pitch decki ile projenin ölçeklenebilirliğini anlattık.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1400&q=80",
        alt: "Aurelia Vertical Farm dış kabuk render",
      },
      {
        src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80",
        alt: "Spiral tarım terasları",
      },
      {
        src: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1400&q=80",
        alt: "İç atriyumda hidroponik hat",
      },
      {
        src: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1400&q=80",
        alt: "Gece modunda kule ışık şovu",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Aurelia%20Vertical%20Farm%20Case",
  },
  {
    id: "vela-tidal-bridge",
    slug: "vela-tidal-bridge",
    label: "Signature Proje",
    title: "Vela Tidal Bridge",
    intro:
      "Vela Tidal Bridge, Lizbon Tagus Nehri üzerinde iki semti birleştirirken gelgit enerjisini kamusal aydınlatmaya dönüştüren sinematik bir köprü deneyimi sunuyor. Kablolu çelik kirişler, yelken formundan ilham alan hafif bir siluet oluşturuyor.",
    meta: [
      "Konum: Tagus Nehri, Lizbon",
      "Ölçek: 620 m uzunluk",
      "Teslim: 10 haftalık sprint",
      "Araçlar: Rhino, Houdini, Unreal, Twinmotion",
    ],
    body: [
      "Gelgit türbinleri, köprü tabliyesine entegre edilerek gece aydınlatmasının enerji ihtiyacı karşılandı. Houdini ile simüle edilen su parçacıkları ve ışık saçılması, köprünün altındaki kamusal alanı yaşayan bir ışık peyzajına dönüştürdü.",
      "Yayalar için tasarlanan duraklama kapsülleri, ses peyzajı ve artırılmış gerçeklik katmanlarıyla şehir tarihini anlattı. Kablolu kirişlerin gece koreografisi, kentsel etkinlik takvimine göre dinamik olarak değişecek şekilde programlandı.",
    ],
    timeline: [
      {
        title: "Akış ve mühendislik",
        description:
          "Akıntı hızlarını hesaplayıp türbin yerleşimini belirledik, köprü taşıyıcılarını optimizasyon algoritmalarıyla hafifleştirdik.",
      },
      {
        title: "Işık ve peyzaj",
        description:
          "Nehir kıyısı peyzajını köprünün ışık senaryosuyla senkronize ederek gece boyunca değişen renk planı kurguladık.",
      },
      {
        title: "Etkinlik koreografisi",
        description:
          "Festival, maraton ve günlük kullanım için üç farklı kullanıcı akışı ürettik, interaktif ışık sıralarını buna göre kodladık.",
      },
    ],
    gallery: [
      {
        src: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1400&q=80",
        alt: "Vela Tidal Bridge gün batımı render",
      },
      {
        src: "https://images.unsplash.com/photo-1505731132164-cca90385e0ad?auto=format&fit=crop&w=1400&q=80",
        alt: "Köprü altındaki kamusal iskele",
      },
      {
        src: "https://images.unsplash.com/photo-1465805139202-a644e217f00e?auto=format&fit=crop&w=1400&q=80",
        alt: "Gece modunda köprü ışık koreografisi",
      },
      {
        src: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1400&q=80",
        alt: "Nehir kenarında köprüye yaklaşım",
      },
    ],
    ctaLabel: "Detaylı case talep et",
    ctaUrl: "mailto:studio@modelerman.com?subject=Vela%20Tidal%20Bridge%20Case",
  },
];
